export function formDataToArray(formData?: FormDataEntryValue | null): string[] {
  if (!formData) return []
  if (typeof formData === 'string') return formData.split(',')
  if (Array.isArray(formData)) return formData
  return []
}
